<template>
    <div class="apprentice-simple-card">
        <design-2021-apprentice-data-table
            :fields="fields"
            :items="currentCoursesComputed"
            :nosearch="true">
            <template #options>
                <b-button
                    class="btn-add btn-add-course"
                    v-b-modal="'project-add-course-modal'"
                    v-if="showAddButton"
                    variant="primary">
                    {{ $t('project.add_new_course') }}
                </b-button>
            </template>

            <template #cell(common)="row">
                <div
                    class="common-status"
                    :class="row.item.common ? 'text-success' : 'text-primary'">
                    <i
                        class="icon fad"
                        :class="row.item.common ? 'fa-check-circle' : 'fa-times-circle'">
                    </i>
                </div>
            </template>

            <template v-slot:cell(actions)="row">
                <b-button
                    class="btn-remove"
                    v-if="allowedToDelete(row.item)"
                    variant="danger-icon-only"
                    @click="deleteCheck(row.item)">
                </b-button>
            </template>
        </design-2021-apprentice-data-table>
        <design-2021-project-add-course-modal-component
            :project-in="project"
            :current-courses-in="currentCoursesComputed"
            :courses="courses">
        </design-2021-project-add-course-modal-component>
        <design-2021-project-delete-course-modal-component
            @deleteSpecific="deleteCourse($event)"
            ref="project-delete-course-modal">
        </design-2021-project-delete-course-modal-component>
    </div>
</template>
<script>
export default {
    name: 'design-2021-project-courses-component',
    props: ['projectIn'],
    data() {
        return {
            project: this.projectIn,
            currentCourses: this.projectIn.courses,
            coursesTableColumns: ['name', 'actions'],
            coursesTableOptions: {
                headings: {
                    name: this.$t('project.course'),
                    actions: this.$t('common.choose'),
                },
                sortable: ['name'],
                filterable: ['name'],
            },
            forceRefresh: 0,
            courses: {},
        };
    },
    computed: {
        fields() {
            let fields = [
                {
                    key: 'name',
                    label: this.$t('project.course'),
                },
            ];
            if (this.projectIn.group.group_pair_options?.course_student_link) {
                if (true) {
                    fields.push({
                        key: 'common',
                        label: this.$t('project.whole_group'),
                    });
                }
                fields.push({
                    key: 'personal',
                    label: this.$t('project.personal_from'),
                });
            }
            fields.push({
                key: 'actions',
                label: this.$t('common.actions'),
            });
            return fields;
        },
        currentCoursesComputed() {
            let courseArray = [...new Map(this.project.courses.map((course) => [course['id'], course])).values()];
            return courseArray.map((course) => {
                let rows = this.project.courses.filter((course2) => course2.id === course.id);
                let common = false;
                let personal = [];
                let personalIds = [];
                let users = [];
                rows.forEach((row) => {
                    if (row.pivot.user_id) {
                        const user = this.project.users.find((user) => user.id === row.pivot.user_id);
                        if (!user) return; // TODO: Why is the user sometimes not found?
                        personal.push(user.full_name);
                        personalIds.push(user.id);
                        users.push(user);
                    } else {
                        common = true;
                    }
                });
                return {
                    refresh: this.forceRefresh,
                    id: course.id,
                    name: course.name,
                    common: common,
                    personal: personal.join(', '),
                    personalIds: personalIds,
                    users: users,
                };
            });
        },
        currentCommonCourses() {
            return this.currentCoursesComputed.filter((course) => course.common);
        },
        currentPersonalCourses() {
            return this.currentCoursesComputed.filter((course) => course.personalIds.includes(this.$authUser.id));
        },
        showAddButton() {
            if (!this.$authUser.isStudent()) {
                return true;
            }

            const courseMax = this.project.group.group_pair_options?.course_max;
            if (!courseMax) {
                return true;
            }
            if (this.project.group.group_pair_options?.course_student_link) {
                return !(
                    this.currentCommonCourses.length >= courseMax && this.currentPersonalCourses.length >= courseMax
                );
            } else {
                return this.currentCourses.length < courseMax;
            }
        },
    },
    methods: {
        deleteCheck(item) {
            if (
                ((item.common &&
                    (item.personalIds.includes(this.$authUser.id) ||
                        this.$authUser.isAdmin() ||
                        this.$authUser.isTeacher())) ||
                    (item.personalIds.length > 1 &&
                        (this.$authUser.isAdmin() || this.$authUser.isTeacher()) &&
                        !item.common)) &&
                this.projectIn.group.group_pair_options?.course_student_link
            ) {
                this.$refs['project-delete-course-modal'].show(item);
            } else {
                if (item.common) {
                    this.alert
                        .confirm(
                            this.$t('project.delete_course'),
                            this.$t('project.are_you_sure_you_want_to_delete_this_course'),
                        )
                        .then((confirm) => {
                            if (confirm) {
                                this.deleteCourse(item.id);
                            }
                        });
                } else {
                    this.alert
                        .confirm(
                            this.$t('project.delete_course'),
                            this.$t('project.are_you_sure_you_want_to_delete_this_course'),
                        )
                        .then((confirm) => {
                            if (confirm) {
                                this.deleteCourse({
                                    userId: this.$authUser.id,
                                    courseId: item.id,
                                });
                            }
                        });
                }
            }
        },
        deleteCourse(dataIn) {
            this.alert.saving();

            let data = {
                courseId: dataIn,
                userId: null,
            };
            if (typeof dataIn === 'object') {
                data.courseId = dataIn.courseId;
                data.userId = dataIn.userId;
            }
            this.axios.post(this.routes.projectDeleteCourses(this.project.id), data).then(
                (response) => {
                    this.project.courses = this.project.courses.filter(
                        (course) => course.id !== data.courseId || course.pivot.user_id !== data.userId,
                    );
                    this.alert.success();
                },
                (error) => {
                    this.alert.ajaxError(error);
                },
            );
        },
        allowedToDelete(data) {
            if (!this.$authUser.isStudent()) {
                return true;
            }

            let courseMin = this.projectIn.group.group_pair_options
                ? this.project.group.group_pair_options.course_min
                : null;
            if (
                !this.projectIn.group.group_pair_options ||
                (this.projectIn.group.group_pair_options && !this.project.group.group_pair_options.course_student_link)
            ) {
                return this.currentCommonCourses.length > courseMin;
            } else {
                let allowedCommon = false;
                let allowedPersonal = false;
                if (data.common) {
                    if (this.currentCommonCourses.length > courseMin) {
                        allowedCommon = true;
                    }
                } else {
                    if (
                        this.currentPersonalCourses.length > courseMin &&
                        (data.personalIds.includes(this.$authUser.id) ||
                            this.$authUser.isAdmin() ||
                            this.$authUser.isTeacher())
                    ) {
                        allowedPersonal = true;
                    }
                }
                return allowedCommon || allowedPersonal;
            }
        },
    },
};
</script>

<style scoped lang="scss">
.common-status {
    font-size: 1.3125rem;
}
</style>
